export const ActionsTypes = {
    // Fetch messages
    'FETCH_MESSAGES_REQUEST': 'FETCH_MESSAGES_REQUEST',
    'FETCH_MESSAGES_SUCCESS': 'FETCH_MESSAGES_SUCCESS',
    'FETCH_MESSAGES_FAILURE': 'FETCH_MESSAGES_FAILURE',

    // Fetch single message
    'FETCH_SINGLE_MESSAGE_REQUEST': 'FETCH_SINGLE_MESSAGE_REQUEST',
    'FETCH_SINGLE_MESSAGE_SUCCESS': 'FETCH_SINGLE_MESSAGE_SUCCESS',
    'FETCH_SINGLE_MESSAGE_FAILURE': 'FETCH_SINGLE_MESSAGE_FAILURE',

    // Send message
    'SEND_MESSAGE_REQUEST': 'SEND_MESSAGE_REQUEST',
    'SEND_MESSAGE_SUCCESS': 'SEND_MESSAGE_SUCCESS',
    'SEND_MESSAGE_FAILURE': 'SEND_MESSAGE_FAILURE',

    // Mark as read
    'MARK_MESSAGE_READ_REQUEST': 'MARK_MESSAGE_READ_REQUEST',
    'MARK_MESSAGE_READ_SUCCESS': 'MARK_MESSAGE_READ_SUCCESS',
    'MARK_MESSAGE_READ_FAILURE': 'MARK_MESSAGE_READ_FAILURE',
};

// Fetch messages actions
export const FETCH_MESSAGES_REQUEST = (payload) => ({
    type: ActionsTypes.FETCH_MESSAGES_REQUEST,
    payload
});

export const FETCH_MESSAGES_SUCCESS = (payload) => ({
    type: ActionsTypes.FETCH_MESSAGES_SUCCESS,
    payload
});

export const FETCH_MESSAGES_FAILURE = (payload) => ({
    type: ActionsTypes.FETCH_MESSAGES_FAILURE,
    payload
});

// Fetch single message actions
export const FETCH_SINGLE_MESSAGE_REQUEST = (payload) => ({
    type: ActionsTypes.FETCH_SINGLE_MESSAGE_REQUEST,
    payload
});

export const FETCH_SINGLE_MESSAGE_SUCCESS = (payload) => ({
    type: ActionsTypes.FETCH_SINGLE_MESSAGE_SUCCESS,
    payload
});

export const FETCH_SINGLE_MESSAGE_FAILURE = (payload) => ({
    type: ActionsTypes.FETCH_SINGLE_MESSAGE_FAILURE,
    payload
});

// Send message actions
export const SEND_MESSAGE_REQUEST = (payload) => ({
    type: ActionsTypes.SEND_MESSAGE_REQUEST,
    payload
});

export const SEND_MESSAGE_SUCCESS = (payload) => ({
    type: ActionsTypes.SEND_MESSAGE_SUCCESS,
    payload
});

export const SEND_MESSAGE_FAILURE = (payload) => ({
    type: ActionsTypes.SEND_MESSAGE_FAILURE,
    payload
});

// Mark as read actions
export const MARK_MESSAGE_READ_REQUEST = (payload) => ({
    type: ActionsTypes.MARK_MESSAGE_READ_REQUEST,
    payload
});

export const MARK_MESSAGE_READ_SUCCESS = (payload) => ({
    type: ActionsTypes.MARK_MESSAGE_READ_SUCCESS,
    payload
});

export const MARK_MESSAGE_READ_FAILURE = (payload) => ({
    type: ActionsTypes.MARK_MESSAGE_READ_FAILURE,
    payload
});

